import type { AnimationType, ItemAnimation } from './animation-item-type';

/**
 * 프리뷰(작은 반복 재생 박스)용 ItemAnimation 을 만든다.
 *
 * 편집 중인 값(customOutputRanges·customInputRanges·customEasings)은 그대로 살리고 시간
 * 필드만 프리뷰 구간으로 갈아끼운다 — 씬 길이(예: 6초)를 그대로 쓰면 combo 애니가 프리뷰
 * 1초 안에서는 거의 정지 화면이 된다. enabled 도 무시한다(꺼둔 애니도 모양은 보여준다).
 */
export const toPreviewAnimation = (
  type: AnimationType,
  durationInSeconds: number,
  animation?: ItemAnimation,
): ItemAnimation => ({
  ...animation,
  timelineWindow: undefined,
  type,
  durationInSeconds,
  startTimeInSeconds: 0,
  endTimeInSeconds: durationInSeconds,
  enabled: true,
});
